import React, { useState, useRef, useEffect } from 'react';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import CccisdToggle from 'cccisd-toggle';
const Boilerplate = window.cccisd.boilerplate;

const Toggle = ({ initialValue, row }) => {
    const [currVal, setCurrVal] = useState(initialValue === 'Yes');
    const [isLoading, setIsLoading] = useState(false);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        (async function toggleBackend() {
            setIsLoading(true);
            try {
                const response = await axios.put(
                    Boilerplate.route('api.nexus.pawn.update', {
                        pawn: row['pawn.pawnId'],
                    }),
                    {
                        pawnHash: row['pawn.pawnHash'],
                        isSupervisionComplete: currVal,
                    }
                );

                if (response?.data?.status === 'success') {
                    notification({ type: 'success', message: 'Supervision status updated!' });
                } else {
                    notification({ type: 'danger', message: 'Failed to update supervision status.' });
                }
            } catch (e) {
                console.error(e);
            }
            setIsLoading(false);
        })();
    }, [currVal]);

    return (
        <div className="d-flex justify-content-center">
            <CccisdToggle
                value={currVal}
                onChange={async () => {
                    if (isLoading) {
                        return;
                    }

                    setCurrVal(prev => !prev);
                }}
                disabled={isLoading}
            />
        </div>
    );
};

export default Toggle;
